<template>
  <v-dialog :value="isOpened" max-width="600px" @input="handleClose">
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title class="font-weight-bold">
          {{ $t('purchaseV2.basket.companyInvoice') }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn @click="handleClose" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-4 px-3">
        <v-form ref="form">
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  v-model="localCompanyName"
                  :label="`${$t('generalAttributes.name')}*`"
                  :rules="[requiredStringRule]"
                  counter="256" />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="localCompanyPidn"
                  :label="`${$t('entities.companies.attributes.pidn')}*`"
                  :rules="[requiredStringRule]"
                  counter="256" />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="localCompanyAddress"
                  :label="`${$t('generalAttributes.address')}*`"
                  :rules="[requiredStringRule]"
                  counter="256" />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions class="py-4">
        <v-btn @click="handleClose" text class="ml-2">
          {{ $t('miscellaneous.cancel') }}
        </v-btn>
        <v-spacer />
        <v-btn @click="handleSave" color="primary" class="mr-2">
          {{ $t('miscellaneous.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CompanyInvoiceDialog',
  props: {
    companyAddress: { type: String, default: '' },
    companyName: { type: String, default: '' },
    companyPidn: { type: String, default: '' },
    isOpened: { type: Boolean, required: true },
  },
  data() {
    return {
      localCompanyAddress: '',
      localCompanyName: '',
      localCompanyPidn: '',
    }
  },
  computed: {
    requiredStringRule() {
      return (v) =>
        (!!v && v.length >= 1 && v.length <= 256) ||
        'Required (1-256 characters).'
    },
  },
  watch: {
    isOpened(value) {
      if (value) {
        this.localCompanyName = this.companyName
        this.localCompanyPidn = this.companyPidn
        this.localCompanyAddress = this.companyAddress
      } else {
        this.resetForm()
      }
    },
  },
  methods: {
    handleClose() {
      this.$emit('dialog:close')
    },
    handleSave() {
      if (!this.$refs.form || !this.$refs.form.validate()) return
      this.$emit('dialog:save', {
        name: this.localCompanyName,
        pidn: this.localCompanyPidn,
        address: this.localCompanyAddress,
      })
    },
    resetForm() {
      if (this.$refs.form) {
        this.$refs.form.reset()
      }
      this.localCompanyName = ''
      this.localCompanyPidn = ''
      this.localCompanyAddress = ''
    },
  },
}
</script>
